<template>
    <component :is="dynamicComponent" />
</template>

<script>
import InsideHeader from "../components/InsideHeader.vue";

export default {
    components: {InsideHeader},
    data(){
        return {
            breadcrumb: [
                {title: 'Home', path:'/'},
                {title: 'Services', path:'#'}
            ],
            params: ''
        }
    },
    computed: {
        dynamicComponent(){
            if(this.params.slug){                
                return () => import(`../components/Service/SingleService`);
            }
            else
                return () => import(`../components/Service/Services`);
        }
    },
    created: function(){
        this.params = this.$route.params
    },
    watch: {
        '$route.params'(){
            this.params = this.$route.params
        }
    }
    
}
</script>